import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(1),
  },
  header: {
    marginTop: 88,
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(4),
    },
  },
  cancerImg: {
    width: 280,
    height: 280,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("lg")]: {
      width: 200,
      height: 200,
    },
    [theme.breakpoints.down("md")]: {
      width: 220,
      height: 220,
    },
    [theme.breakpoints.down("sm")]: {
      width: 140,
      height: 140,
    },
  },
  lung: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    backgroundImage: "url(/images/main/cancer_lung_nor.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  },
  prostate: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    backgroundImage: "url(/images/main/cancer_prostate_nor.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  },
  breast: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    backgroundImage: "url(/images/main/cancer_breast_nor.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  },
  thyroid: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    backgroundImage: "url(/images/main/cancer_thyroid_nor.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
    backgroundSize: "cover",
  },
  regular: {
    fontWeight: 400,
    lineHeight: 1.4,
  },
  bold: {
    fontSize: 28,
    fontWeight: 500,
    [theme.breakpoints.down("md")]: {
      fontSize: 24,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: 22,
    },
  },
  body: {
    marginTop: 40,
    height: 500,
    marginBottom: 37.5,
    [theme.breakpoints.down("md")]: {
      marginTop: 10,
    },
    [theme.breakpoints.down("sm")]: {
      height: "auto",
    },
  },
  selectList: {
    width: 1280,
    height: 500,
    [theme.breakpoints.down("lg")]: {
      flex: 1,
      padding: 20,
      // height: 220,
    },
    [theme.breakpoints.down("md")]: {
      flex: 1,
      padding: 100,
      // height: 220,
    },
    [theme.breakpoints.down("sm")]: {
      flex: 1,
      alignSelf: 'stretch',
      flexDirection: "row",
      height: "auto",
      // height: 220,
      padding: 24,
      paddingRight: 30,
    },
  },
  onImg: {
    borderRadius: "50%",
    border: `5px solid ${theme.palette.background.default}`,
  },
  footer: {
    // position: "absolute",
    // bottom: 30,
    width: "100%",
    textAlign: "center",
  },
  button: {
    width: 432,
    height: 78,
    fontSize: 20,
  },
  tems: {
    [theme.breakpoints.down("md")]: {
      marginBottom: 40,
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 32,
    },
  },
  item: {
    cursor: "pointer",
    "&:hover": {
      "& > div > div > div": {
        border: `5px solid ${theme.palette.primary.main}`,
      },
      color: theme.palette.primary.main,
      fontWeight: 700,
    },
  },
  large: {
    display: "block",
    [theme.breakpoints.down("lg")]: {
      fontSize: 32,
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));

const SelectComp = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleChange = (num = 1) => {
    // setView(num);
    if (num === 1) {
      history.push(`/lungcancer`);
    } else if (num === 2) {
      history.push(`/prostatecancer`);
    } else if (num === 3) {
      history.push(`/breastcancer`);
    } else if (num === 4) {
      history.push(`/thyroidcancer`);
    }    
  };
  return (
    <Grid container direction="column" className={classes.root}>
      <Grid
        container
        justify="center"
        direction="column"
        alignItems="center"
        className={classes.header}
      >
        <Typography align="center" variant="h2">
          <span className={clsx(classes.regular, classes.large)}>
            검진 받을 것을 고려하시는 암의 종류를 선택해주세요.
          </span>
          <span className={clsx(classes.regular, classes.small)}>
            검진 받을 것을 고려하시는
            <br /> 암의 종류를 선택해주세요.
          </span>
        </Typography>
      </Grid>
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.body}
      >
        <Grid
          container
          alignItems="center"
          justify="space-evenly"
          className={classes.selectList}
        >
          <Grid className={classes.item} onClick={() => handleChange(1)}>
            <Grid
              container
              justify="center"
              direction="column"
              alignItems="center"
              className={classes.tems}
            >
              <div className={classes.cancerImg}>
                <div
                  className={clsx(
                    classes.lung,
                    classes.onImg
                    // view === 1 ? classes.onImg : null
                  )}
                ></div>
              </div>
              <Typography variant="h3">
                <span className={classes.bold}>폐암</span>
              </Typography>
            </Grid>
          </Grid>
          <Grid className={classes.item} onClick={() => handleChange(2)}>
            <Grid
              container
              justify="center"
              direction="column"
              alignItems="center"
              className={classes.tems}
            >
              <div className={classes.cancerImg}>
                <div
                  className={clsx(
                    classes.prostate,
                    classes.onImg
                    // view === 2 ? classes.onImg : null
                  )}
                ></div>
              </div>
              <Typography variant="h3">
                <span className={classes.bold}>전립선암</span>
              </Typography>
            </Grid>
          </Grid>
          <Grid className={classes.item} onClick={() => handleChange(3)}>
            <Grid
              container
              justify="center"
              direction="column"
              alignItems="center"
              className={classes.tems}
            >
              <div className={classes.cancerImg}>
                <div
                  className={clsx(
                    classes.breast,
                    classes.onImg
                    // view === 2 ? classes.onImg : null
                  )}
                ></div>
              </div>
              <Typography variant="h3">
                <span className={classes.bold}>유방암</span>
              </Typography>
            </Grid>
          </Grid>
          <Grid className={classes.item} onClick={() => handleChange(4)}>
            <Grid
              container
              justify="center"
              direction="column"
              alignItems="center"
              className={classes.tems}
            >
              <div className={classes.cancerImg}>
                <div
                  className={clsx(
                    classes.thyroid,
                    classes.onImg
                    // view === 2 ? classes.onImg : null
                  )}
                ></div>
              </div>
              <Typography variant="h3">
                <span className={classes.bold}>갑상선암</span>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid className={classes.footer}>
        <Button
          onClick={handleLink}
          variant="contained"
          color="primary"
          className={classes.button}
        >
          다음으로
        </Button>
      </Grid> */}
    </Grid>
  );
};

export default SelectComp;
